import styled from 'styled-components';
import { theme } from '../../../../shared/const/theme';
import { BASE_PADDING, TABS_HEIGHT } from '../../constants';
import { CallToAction } from '../../../../shared/components/CallToAction';
export const Wrapper = styled.div.withConfig({
    componentId: "sc-3eb1276-0"
})([
    `position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;padding:16px;background-color:#fff;overflow:auto;transition:opacity 200ms,transform 200ms;`,
    ` @media (min-width:`,
    `px){padding:`,
    `;padding-bottom:0;}`
], (p)=>!p.show && 'opacity: 0; pointer-events: none; transform: translateX(100%);', theme.waffle.breakpoints.md, ({ $tabsCollapsed })=>$tabsCollapsed ? `${BASE_PADDING}px 40px` : `${BASE_PADDING + TABS_HEIGHT}px 40px`);
export const BackButton = styled.button.withConfig({
    componentId: "sc-3eb1276-1"
})([
    `display:flex;background-color:transparent;border:none;font-family:inherit;color:`,
    `;font-size:inherit;padding:16px 12px;cursor:pointer;align-items:center;justify-content:flex-start;gap:12px;&:hover{text-decoration:underline;}&:focus-visible{outline:`,
    ` auto 1px;}`
], theme.waffle.colors.text.accent, theme.waffle.colors.outline.focus);
const headingStyle = `
  color: ${theme.waffle.colors.text.default};
  font-size: 21px;
  font-weight: 500;
  padding: 16px 12px;

  &:has(+ div img) {
    padding-left: 0;
  }
`;
export const Heading = styled.div.withConfig({
    componentId: "sc-3eb1276-2"
})([
    ``,
    ``
], headingStyle);
export const HeadingLink = styled.a.withConfig({
    componentId: "sc-3eb1276-3"
})([
    ``,
    ` text-decoration:none;&:hover{text-decoration:underline;}&:focus-visible{outline:`,
    ` auto 1px;}`
], headingStyle, theme.waffle.colors.outline.focus);
export const List = styled.div.withConfig({
    componentId: "sc-3eb1276-4"
})([
    `display:flex;flex-direction:column;`
]);
const listItemStyle = `
  padding: 16px 12px;
  text-decoration: none;
  font-size: inherit;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${theme.waffle.colors.outline.focus} auto 1px;
  }
`;
export const ListItemLink = styled.a.withConfig({
    componentId: "sc-3eb1276-5"
})([
    ``,
    ` color:`,
    `;`,
    ``
], listItemStyle, ({ color })=>{
    var _a, _b;
    return ((_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a[color]) === null || _b === void 0 ? void 0 : _b.default) || theme.waffle.colors.text.default;
}, ({ $bold })=>$bold && `font-weight: ${theme.typography.fontWeights.medium};`);
export const ListItemButton = styled.button.withConfig({
    componentId: "sc-3eb1276-6"
})([
    ``,
    ` display:flex;background-color:transparent;border:none;font-family:inherit;transition:color 200ms;cursor:pointer;border-top:`,
    `;justify-content:space-between;align-items:center;`
], listItemStyle, (p)=>p.withDivider ? '1px solid #F3F3F5' : 'none');
export const ContentWrapper = styled.div.withConfig({
    componentId: "sc-3eb1276-7"
})([
    `display:flex;flex-direction:column;justify-content:space-between;height:100%;`
]);
export const StyledImage = styled.img.withConfig({
    componentId: "sc-3eb1276-8"
})([
    `width:20px;height:20px;border-radius:50%;`
]);
export const LinkWrapper = styled.div.withConfig({
    componentId: "sc-3eb1276-9"
})([
    `display:flex;align-items:center;border-top:`,
    `;padding-left:`,
    `;&:has(img) + div:not(:has(img)){padding-left:0;}`
], (p)=>p.withDivider ? '1px solid #F3F3F5' : 'none', (p)=>p.$paddingLeft ? '12px' : 'auto');
export const BottomCallToAction = styled(CallToAction).withConfig({
    componentId: "sc-3eb1276-10"
})([
    ``,
    ` width:100%;margin-top:16px;padding-left:0;justify-content:space-between;font-weight:400;line-height:20px;`
], listItemStyle); //# sourceMappingURL=SubLevel.styled.js.map
